
<template>
  <div
    class="final-docs__exempt"
  >
    <div
      v-if="shouldShowExemptHint"
      class="final-docs__exempt-checkbox"
      @click.prevent="openExemptModel"
    >
      <input
        v-model="pendingValue"
        :class="{'not-allowed': isDisable}"
        class="final-docs__cursor"
        type="checkbox"
        :disabled="isDisable"
      >
    </div>
    <div
      v-if="shouldShowExemptHint"
      class="final-docs__exempt-hint"
    >
      <span
        :class="hintClassName"
        @click.prevent="openExemptModel"
      >
        {{ $t('tenantProjects.finalDocuments.exemptHint') }}
      </span>
    </div>
    <HKLModal
      ref="exemptModalRef"
      okBtnAction="yesExempt"
      cancelBtnAction="goback"
      :title="$t('tenantProjects.finalDocuments.exemptModalHint')"
      @onOkClick="exempt"
    />
  </div>
</template>

<script>
import { computed, ref, unref, watchEffect } from 'vue-demi'
import { FINAL_DOC_STATUS } from '../../consts'
import { useFinalDocExemptAccess, useFinalDocStatus } from './hook'
import HKLModal from '@/controls/Modal/HKLModal'
import { useStoreActions, useStoreGetters } from '@/store'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { EmailTypes } from '@/utils/consts'
import { sendEmail } from '@/api/postman/request'

export default {
  components: {
    HKLModal,
  },
  setup () {
    const { isHKlandUser, isTenant } = useStoreGetters('user', ['isHKlandUser', 'isTenant'])
    const hasExemptAccess = useFinalDocExemptAccess()
    const shouldShowExemptHint = computed(() => {
      const showForTenant = unref(isExempted) && unref(isTenant)
      return unref(isHKlandUser) || showForTenant
    })
    const pendingValue = ref(false)

    const isCompleted = useFinalDocStatus(FINAL_DOC_STATUS.COMPLETED)
    const isExempted = useFinalDocStatus(FINAL_DOC_STATUS.EXEMPTED)

    watchEffect(() => {
      pendingValue.value = unref(isExempted)
    })
    const isDisable = computed(() => {
      return !unref(hasExemptAccess) || (unref(isCompleted) || unref(isExempted))
    })

    const { updateFinalDocument } = useStoreActions('tenantProject', ['updateFinalDocument'])
    const exempt = async () => {
      await updateFinalDocument({ status: FINAL_DOC_STATUS.EXEMPTED })
      if (unref(isExempted)) {
        await sendEmail(EmailTypes.tenantProjects.exemptFinalDocuments)
      }
    }
    const hintClassName = computed(() => {
      const className = unref(isTenant) ? [] : ['final-docs__cursor', {'not-allowed': unref(isDisable)}]
      return className
    })
    const exemptModal = useRefModal()
    const openExemptModel = () => {
      if (unref(isDisable)) return
      exemptModal.open()
    }
    return {
      hintClassName,
      pendingValue,
      isDisable,
      isCompleted,
      isExempted,
      hasExemptAccess,
      isHKlandUser,
      shouldShowExemptHint,
      exempt,
      exemptModalRef: exemptModal.modal,
      openExemptModel,
    }
  },
}

</script>
<style lang="scss" scoped>
.final-docs {
  .final-docs__cursor {
    cursor: pointer;
    &.not-allowed {
      cursor: not-allowed;
    }
  }
  &__exempt {
    display: flex;
    flex-grow: 1;
    flex-basis: inherit;
    align-items: center;
  }
  &__exempt-checkbox {
    flex: 0 0 24px;
    input {
      display: block;
    }
  }
  &__exempt-hint {
    flex: 1
  }
}
</style>
